import { Select as FASTSelect } from '@microsoft/fast-components';
import { foundationSelectStyles as styles } from './select.styles';
import { foundationSelectTemplate as template } from './select.template';
/**
 * @tagname %%prefix%%-select
 */
export class Select extends FASTSelect {
}
// explicitly declaring for extensibility
export const foundationSelectShadowOptions = undefined;
export const defaultSelectConfig = {
    indicator: `
        <svg
            class="select-indicator"
            part="select-indicator"
            viewBox="0 0 12 7"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M11.85.65c.2.2.2.5 0 .7L6.4 6.84a.55.55 0 01-.78 0L.14 1.35a.5.5 0 11.71-.7L6 5.8 11.15.65c.2-.2.5-.2.7 0z"
            />
        </svg>
    `,
};
/**
 * The Foundation Select
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-select\>
 */
export const foundationSelect = Select.compose(Object.assign({ baseName: 'select', template,
    styles, shadowOptions: foundationSelectShadowOptions }, defaultSelectConfig));
